import { posAxiosClient } from '@kinderlabs-pos/apis/axios';
import { PaymentInfoType, ReceiptInfoType } from '@kinderlabs-pos/shared-data-type';

export const cancelCashReceiptAsync =
	(rootUrl: string) =>
	async ({ storeId, posId, paymentId, receipt }: CancelReceiptRequestType) =>
		(
			await posAxiosClient.post<PaymentInfoType>(
				`${rootUrl}/payment/store/${storeId}/pos/${posId}/payment/receipt/cancel`,
				receipt,
				{
					params: {
						paymentId,
					},
				}
			)
		).data;

export type CancelReceiptRequestType = {
	storeId: number;
	posId: number;
	paymentId: string;
	receipt: ReceiptInfoType;
};
